<template>
  <div>
    <div class="report-detail">
      <div class="detail-l">
        <Spin fix v-if="loading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        <div class="detail-t">
          <div class="report-img">
            <img :src="detail.logo_path | logo_show" />
          </div>
          <div class="report-info">
            <p class="title">{{detail.title}}</p>
            <p class="dec">
              <span v-if="detail.src_author !== ''">{{detail.src_author}}</span>
              <span>{{detail.publish_time | timeTrans}}</span>
              <span v-if="filter.dealName(detail.category_id, report_type) != '--'">{{detail.category_id | dealName(report_type)}}</span>
            </p>
            <p class="price"><template v-if="detail.price > 0">￥<span>{{detail.price}}</span></template><template v-else>免费</template></p>
            <a class="buy-btn collect-btn on" v-if="detail.is_collect == 1" @click="cancelCollect('1', detail.id, delCollectCb)">已收藏</a>
            <a class="buy-btn collect-btn" v-else @click="addCollect('1', detail.id, addCollectCb)">添加收藏</a>
            <!-- <a class="buy-btn" v-if="!isVIP && detail.buy_status == 0 && detail.price > 0" @click="goBuy">报告购买</a> -->
            <a class="buy-btn" @click="deModel()">报告下载</a>
          </div>
        </div>
        <div class="detail-b">
          <div class="title-header">
            <span :class="detail_b == 1 ? 'title-p' : 'title'" @click="catalogue(1)">报告亮点</span>
            <span :class="detail_b == 2 ? 'title-p' : 'title'" @click="catalogue(2)">目录</span>
            <span :class="detail_b == 3 ? 'title-p' : 'title'" @click="reportSearch()">报告正文</span>
          </div>
          <div v-show="detail_b == 1" class="tabpane-content" v-html="detail.description"></div>
          <div v-show="detail_b == 2" class="tabpane-content" v-html="detail.catalog"></div>
          <div v-show="detail_b == 3" class="tabpane-content">
            <iframe id="pdf-viewer" :src="protocol + '//static-cdn.vcbeat.top/pdf/web/viewer.html?file=' + $store.state.img_req_url + detail.file_path" width="100%" height="860"></iframe>
          </div>
        </div>
      </div>
      <RightModel class="detail-r">
        <div class="r-content">
          <div class="relation" v-if="detail.attachment.length > 0">
            <div class="title">
              <span class="left">报告相关图表</span>
            </div>
            <div class="relation-list">
              <div class="relation-item" v-for="item, index in detail.attachment" :key="index" @click="handleChangePage(index,item.page_no)">
                <div class="left">
                  <img :src="item.file_path | logo_show('/report_image')" />
                  <img v-if="index > 1" class="lock" :src="$store.state.static_img_url+'pic/lock-close.png'">
                </div>
                <div class="right">
                  <div class="title">{{item.file_name}}</div>
                  <div class="desc">点击跳转该图表所在位置</div>
                </div>
              </div>
            </div>
          </div>
          <div class="more-list">
            <div class="title">
              <span class="left">相关推荐</span>
              <!-- <span class="right">查看更多</span> -->
            </div>
            <Spin v-if="loading2" style="margin-top: 20px">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
            <ul>
              <li v-for="item in recommend_list" :key="item.id" @click="clickRecommend(item)">
                <div class="img">
                  <img :src="item.logoPath | logo_show" />
                </div>
                <div class="right">
                  <div class="name">{{item.title}}</div>
                  <div class="desc">
                    <span>{{item.price && item.price > 0 ? ('￥' + item.price) : '免费'}}</span>
                    <span>{{item.srcAuthor}}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

      </RightModel>
      <Modal v-model="reportIndex" @on-visible-change="reportModalCancel" :footer-hide="true" width="458" class="page-modal">
        <img :src="$store.state.static_img_url + 'pic/model/report-upload-model.png'" />
        <p class="p1">亲，今日下载量已耗尽~</p>
        <p class="p2">成为VIP会员， 下载量不受限。</p>
        <router-link to="/buyVip" class="go-vip-btn">立即成为VIP会员</router-link>
      </Modal>
      <FinishInfoAndPay ref="pay" :pricearr="[detail]" :buytype="'1'"></FinishInfoAndPay>
      <DownloadReport ref="downloadReport"></DownloadReport>
    </div>
  </div>
</template>
<script>
import FinishInfoAndPay from '../../components/FinishInfoAndPay'
import DownloadReport from '@/components/DownloadReport'
import {
  reportDetail,
  getMeta,
  getQualityReportList,
  getNumOfreadReport,
  addPuv,
  updateAccount,
} from '../../service'
import { userInfo } from 'js/userInfo'
import filter from 'js/filter'
import RightModel from '@/components/RightModel'
import { collect_mixin } from 'js/collect_mixin'
export default {
  metaInfo() {
    return {
      title: this.meta_title,
    }
  },
  inject: ['reload', 'haddleApplyTry', 'login'],
  mixins: [userInfo, collect_mixin],
  components: { FinishInfoAndPay, RightModel, DownloadReport },
  data() {
    return {
      isAgree: false,
      loading: true,
      loading2: true,
      filter: filter,
      isFlash: false,
      detail: {
        attachment: [],
      },
      report_type: [],
      recommend_list: [],
      had_read_report: [],
      rad_num: 0,
      reportIndex: false,
      // info_model: false,
      // info_form: {
      //   name: '',
      //   comp_name: '',
      //   title: '',
      //   email: '',
      //   other_requirement: ''
      // },
      // info_rules: {
      //   name: [
      //     { required: true, message: '请填写姓名', trigger: 'blur' }
      //   ],
      //   comp_name: [
      //     { required: true, message: '请填写公司或机构名称', trigger: 'blur' }
      //   ],
      //   title: [
      //     { required: true, message: '请填您的职位', trigger: 'blur' }
      //   ],
      //   email: [
      //     { required: true, message: '请填写邮箱', trigger: 'blur' },
      //     { type: 'email', message: '请填写正确的邮箱', trigger: 'blur' }
      //   ],
      // },
      detail_b: 1,
      viewer_dom: '',

      meta_title: '动脉橙-数字健康产业信息服务商',
    }
  },
  computed: {
    req_url() {
      return this.$store.state.req_url
    },
    protocol() {
      return window.location.protocol
    },
  },
  methods: {
    addCollectCb() {
      this.detail.is_collect = 1
      this.detail = { ...this.detail }
    },
    delCollectCb() {
      this.detail.is_collect = 0
      this.detail = { ...this.detail }
    },
    catalogue(type) {
      this.detail_b = type
      if (type == 2) {
        _czc.push(['_trackEvent', '报告详情页(新)', '报告详情页(目录)', '点击量'])
      }
    },
    deModel() {
      if (!this.user_key) {
        this.login()
        return
      }
      if (!this.detail.file_path) {
        this.goBuy()
        return
      }
      let user = this.user
      const { name, email, title } = user
      let compName = user.compName || user.compName || ''
      if (!(name && compName && email && title)) {
        this.$refs['downloadReport'].modelIndex = true
        this.$refs['downloadReport'].reportId = this.detail.id
        this.$refs['downloadReport'].reportUid = this.detail.uid
      } else {
        this.handleClickSure()
      }
    },
    reportSearch() {
      if (!this.user_key) {
        this.login()
        return
      }
      if (this.detail.file_path) {
        this.detail_b = 3
      } else {
        this.goBuy()
      }
    },
    handleChangePage(index, num) {
      _czc.push(['_trackEvent', '报告详情页(新)', '报告详情页(相关图表)', '点击量'])
      if (!this.user_key) {
        this.login()
        return
      }
      if (!this.detail.file_path) {
        this.goBuy()
        return
      }
      if (index < 2) {
        let page = num - 0
        this.viewer_dom.contentWindow.postMessage({ page: page }, '*')
        this.detail_b = 3
      } else {
        this.haddleApplyTry(
          '温馨提示',
          '报告锚点功能动脉橙机构版无限制，欢迎试用动脉橙机构版。',
          14
        )
      }
    },
    async addPuv(url, id) {
      let puv_params = {
        user_key: this.user_key,
        url: url,
        row_id: id,
      }
      let res = await addPuv(puv_params, (error) => this.$Message.error('请求错误！'))
      // this.getNumOfreadReport()
    },
    /**
     * 按需获取元数据
     */
    async getMeta() {
      let res = await getMeta(
        {
          name: ['report_type'],
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.status == 'success') {
        this.$set(this.$data, 'report_type', res.meta.report_type)
      } else {
        this.$Message.error(res.message)
      }
    },
    async getReportDetail() {
      let res = await reportDetail(
        { uid: this.$route.params.uid, user_key: this.user_key },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.status == 'success') {
        this.$set(this.$data, 'detail', res.res[0])
        this.meta_title = this.detail.title + '-动脉橙'
        this.loading = false
      } else {
        this.$Message.error(res.message)
      }
    },
    async recommendReport() {
      let res = await getQualityReportList({ limit: 3 }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {
        this.recommend_list = res.data
        this.loading2 = false
      } else {
        this.$Message.error(res.message)
      }
    },
    async handleClickSure() {
      let user = this.user
      const { name, email, title, compName, entityId } = user
      let params = {
        user_key: this.user_key,
        agree_status: 1,
        uid: this.$route.params.uid,
        data: {
          name: name,
          comp_name: compName,
          entity_id: entityId,
          title: title,
          email: email,
        },
      }
      let res = await updateAccount(params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$Message.success('保存成功！')
        this.handleOpenReport()
      } else {
        this.$Message.error(res.message)
      }
    },
    handleOpenReport() {
      let q = JSON.stringify({ user_key: this.user_key, uid: this.detail.uid })
      let url = this.req_url + '/dg/reportfile?query=' + q
      this.addPuv(url, this.detail.id)
      window.open(url)
    },
    goBuy() {
      // 买报告
      if (!this.user_key) {
        this.login()
        return
      }
      if (this.user.name && this.user.compName && this.user.title) {
        this.$refs['pay'].showInfo(2, this.detail.title, this.getReportDetail)
      } else {
        this.$refs['pay'].showInfo(1, this.detail.title, this.getReportDetail)
      }
    },
    clickRecommend(item) {
      // 点击推荐
      _czc.push(['_trackEvent', '报告详情页(新)', '报告详情页(相关推荐)', '点击量'])
      window.open(
        window.location.protocol + '//' + window.location.host + '/reportDetail/' + item.uid
      )
    },
    async getNumOfreadReport(cb) {
      let res = await getNumOfreadReport({ user_key: this.user_key }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.had_read_report = res.report_ids
        this.rad_num = res.res
        if (cb) {
          cb(res)
        }
      } else {
        this.$Message.error(res.message)
      }
    },
    reportModalCancel(value) {
      this.reportIndex = value
    },
    goToPravicy() {
      const { href } = this.$router.resolve({ name: 'Privacy' })
      window.open(href, '_blank')
    },
  },
  created() {
    if (!this.user_key) {
      this.login()
    }
    this.getMeta()
    this.getReportDetail()
    this.recommendReport()
  },
  mounted() {
    this.$nextTick(() => {
      this.viewer_dom = document.getElementById('pdf-viewer')
    })
  },
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/report.stylus'
.info-form
  padding 20px 20px 20px 0
  .tip
    line-height 1
    margin-top 6px
    color #999
  .ivu-form-item:last-child
    margin-bottom 0
.update-btn
  background-color #FA5A00
  border-color #FA5A00
  &:hover
    background-color #f90
    border-color #f90
.footer-wrap
  display flex
  justify-content space-between
  align-items center
  .flash
    color #fc3b3b
    animation flash 0.1s linear 2
@keyframes flash
  from
    transform translateY(-3px)
  to
    transform translateY(3px)
</style>
